<template>
  <div>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/admin">
        <!--<img src="@/assets/images/logo_cleverdocs_blanc.png" alt="" height="55px" width="130px">-->
        <img src="https://cleverdocs.cleverbsolutions.com/img/logo_cleverdocs.e80bdb8e.png" alt="" height="55px" width="130px">
      </router-link>
      <button type="button" style="display:none" @click="countDocuments">
      COUNTING
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <base-dropdown v-if="user" tag="li" class="user-menu">
            <template slot="title">
              <!-- Name and company beside the avatar, one per line. The role is not
                   repeated here: it stays in the header of the dropdown, which keeps
                   showing the three of them. -->
              <span class="user-trigger">
                <span class="user-trigger__identity">
                  <span class="user-trigger__name">{{user.name}}</span>
                  <span class="user-trigger__company" v-if="user.client">{{user.client.name}}</span>
                </span>
                <span class="user-avatar">
                  <i class="icon-svg icon-user"></i>
                  <span class="user-avatar__dot"></span>
                </span>
              </span>
            </template>
            <span class="user-menu__arrow"></span>
            <div class="user-menu__header">
              <span class="user-avatar user-avatar--sm">
                <i class="icon-svg icon-user"></i>
                <span class="user-avatar__dot"></span>
              </span>
              <div class="user-menu__identity">
                <p class="user-menu__name">{{user.name}}</p>
                <p class="user-menu__company" v-if="user.client">{{user.client.name}}</p>
                <p class="user-menu__role" v-if="user.rol_id == 1">{{roleLabel}}</p>
              </div>
            </div>
            <div class="divider"></div>
            <a class="dropdown-item user-menu__item" @click="modal_password = true">
              <i class="icon-svg icon-key"></i>{{$t("change_password")}}
            </a>
            <a class="dropdown-item user-menu__item" @click="showNotificationsModal()">
              <i class="icon-svg icon-bell"></i>{{$t("submenu_noti_title")}}
            </a>
            <div class="divider"></div>
            <button class="dropdown-item user-menu__item" @click="logout()">
              <i class="icon-svg icon-logout"></i>{{$t("Salir")}}
            </button>
          </base-dropdown>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Fuera de <nav>: al llevar position:fixed crea su propio contexto de
       apilamiento, así que cualquier modal anidado dentro quedaba topado
       por el z-index del propio navbar (99) sin importar el suyo propio,
       apareciendo por debajo del sidebar en vez de cubrirlo. -->
    <modal class="cd-modal" @accept="onSaveNotifications ()" :size="'lg'" :btnAcceptText="$t('Guardar')" @close="modal_noti=false" :showClose="true" v-if="modal_noti" :showfooter="true" :showBtnCancel="false" :title="$t('Avisarme cuando se realicen cambios')">
      <label class="cd-form-label" for="title_noti">{{$t("Titulo de la Notificación")}}</label>
      <input id="title_noti" v-model="titleNoti" @input="readTitle()" class="form-control" name="title_noti" type="text"/>
      <hr>
      <label class="cd-form-label">{{$t("Cuando enviar la notificación")}}</label>
      <div class="cd-radio-group">
        <label class="cd-radio">
          <input v-model="notification_time" @click="onChangeNotification(0)" name="notiGroup" value="0" type="radio"/>
          <span class="cd-radio__mark"></span>
          <span class="cd-radio__text">{{$t("Nunca")}}</span>
        </label>
        <label class="cd-radio">
          <input v-model="notification_time" @click="onChangeNotification(1)" name="notiGroup" value="1" type="radio"/>
          <span class="cd-radio__mark"></span>
          <span class="cd-radio__text">{{$t("Si se sube un archivo o carpeta")}}</span>
        </label>
        <label class="cd-radio">
          <input v-model="notification_time" @click="onChangeNotification(2)" name="notiGroup" value="2" type="radio"/>
          <span class="cd-radio__mark"></span>
          <span class="cd-radio__text">{{$t("Si se comenta un archivo")}}</span>
        </label>
        <label class="cd-radio">
          <input v-model="notification_time" @click="onChangeNotification(3)" name="notiGroup" value="3" type="radio"/>
          <span class="cd-radio__mark"></span>
          <span class="cd-radio__text">{{$t("Las dos opciones anteriores")}}</span>
        </label>
      </div>
      <!--<div class="modal_button calibri px-3 text-justify">
        <div class="mb-4 text-center ">
          <button class="btn btn-md btn-primary btn-fill my-1 px-5 py-1 font-weight-bold">
            <i class="fas fa-check mr-2"></i>
            {{$t('aceptar')}}
          </button>
        </div>
      </div>-->
    </modal>
    <modal :size="'lg'" class="cd-modal w-full" v-if="modal_lodp" :showfooter="false" :showBtnCancel="false" :title="$t('ley_lopd')">
      <!-- The accept button sits inside the scrolling area on purpose: it can
           only be reached after scrolling through the policy. -->
      <div class="cd-lopd-text text-justify">
        <ley_rgpd></ley_rgpd>
        <div class="cd-lopd-actions">
          <button class="btn btn-primary" @click="onAcceptLopd">
            <i class="fas fa-check"></i>
            {{$t('aceptar')}}
          </button>
        </div>
      </div>
    </modal>
    <modal class="cd-modal" @accept="onChangePassword" @close="onCloseChangePassword" :size="'md'" :btnAcceptText="$t('Actualizar')" :showClose="true" v-if="modal_password" :showfooter="true" :showBtnCancel="false" :title="$t('change_password')">
      <label class="cd-form-label" for="cp_password">{{$t('Password')}}</label>
      <input id="cp_password" v-model="cp_password" class="form-control" type="password" :placeholder="$t('Password')"/>
      <span class="cd-form-error" v-if="$v.cp_password.$error">
        <span v-if="!$v.cp_password.required">{{$t("password_required")}}</span>
        <span v-else-if="!$v.cp_password.minLength">{{$t("password_length")}}</span>
      </span>
      <label class="cd-form-label mt-3" for="cp_confirm_password">{{$t('confirmPassword')}}</label>
      <input id="cp_confirm_password" v-model="cp_confirm_password" class="form-control" type="password" :placeholder="$t('confirmPassword')"/>
      <span class="cd-form-error" v-if="$v.cp_confirm_password.$error">
        <span v-if="!$v.cp_confirm_password.required">{{$t("confirm_password_required")}}</span>
        <span v-else-if="!$v.cp_confirm_password.minLength">{{$t("confirm_password_length")}}</span>
        <span v-else-if="!$v.cp_confirm_password.sameAsPassword">{{$t("confirm_password_equal")}}</span>
      </span>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ley_rgpd from "@/components/ley_rgpd.vue"
import Modal from "@/components/Modal.vue";
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

  export default {

    data () {
      return {
        notification_time:this.onChangeNotification(3),
        titleNoti: "",
        checkedNoti: "3",
        activeNotifications: false,
        modal_lodp : false,
        modal_noti : false,
        modal_password : false,
        cp_password : null,
        cp_confirm_password : null,
        isAdmin : false
      }
    },
    validations () {
      return {
        cp_password : {
          required,
          minLength : minLength(8)
        },
        cp_confirm_password : {
          required,
          minLength : minLength(8),
          sameAsPassword : sameAs('cp_password')
        }
      }
    },
    computed: {
        ...mapGetters({
            user: 'login/user',
            notifications: 'login/notifications',
            lang: 'login/lang',
            document_not : 'login/document_notifications'
        }),
        roleLabel ()
        {
          return this.user && this.user.roles ? this.user.roles.name : '';
        }
    },
    components: {
      ley_rgpd,
      Modal
    },
    created ()
    {
      this.isAdmin = this.user.rol_id == 1;
      this.onLoadNotifications ();
      // External contacts and employees accept the RGPD notice.
      if (!this.isAdmin) this.onLoadModalRgpd ();

    },
    methods: {

      onChangeLang (locale)
      {
        this.$i18n.locale = locale;
        this.$store.dispatch ('login/changeLang', locale);
      },
      capitalizeFirstLetter (string)
      {
        return string.charAt (0).toUpperCase () + string.slice (1)
      },
      onLoadNotifications ()
      {
        if (this.isAdmin)
        {
          this.$store.dispatch ('login/onLoadNotifications');
          this.$store.dispatch ('login/documentNotifications');        
        }
      },
      toggleNotificationDropDown ()
      {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown ()
      {
        this.activeNotifications = false;
      },
      countDocuments()
      {
        this.$store.dispatch ('isLoadingOn');
        this.$axios ("/document/total_docs")
            .then (() => {
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            })
      },
      showNotificationsModal(){
        let data = {
          user_id            : this.user.id,
        };
        this.$axios.post ("/client/get_user", data)
            .then ((response) => {
              this.titleNoti = response.data.title_notification != " " ? response.data.title_notification : 'Notificación';
              this.notification_time=response.data.notification != "" ? response.data.notification : 3;
              this.modal_noti = true;
              if (!response?.data || Object.keys(response.data).length === 0) {
                this.titleNoti ='Notificación';
                this.notification_time = 3;
                this.checkedNoti = 3;
              }
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            })
      },
      logout ()
      {
        this.$store.dispatch ('login/logout');
      },
      onSaveNotifications (){
        let data= {
          notification            : this.checkedNoti,
          title_notification      : this.titleNoti,
        };
        this.$store.dispatch ('isLoadingOn');
        this.$axios.post ("/client/save_noti", data)
            .then (() => {
              this.modal_noti = false;
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            })
      },
      readTitle(){
      },
      onChangeNotification(value){
        this.checkedNoti = value;
      },
      onAcceptLopd ()
      {
        this.$store.dispatch ('isLoadingOn');
        this.$axios ("/client/accept_lodp")
        .then (() => {
          this.modal_lodp = false;
          this.$store.dispatch ('isLoadingOff');
        })
        .catch (() => {
          this.$store.dispatch ('isLoadingOff');
        })
      },  
      onLoadModalRgpd ()
      {
        this.$store.dispatch ('isLoadingOn');
        this.$axios ("/client/check_lodp")
        .then ((response) => {
          let user = response.data;
          this.modal_lodp = !user.lodp_accept;
          this.$store.dispatch ('isLoadingOff');
        })
        .catch (() => {
          this.$store.dispatch ('isLoadingOff');
        })
      },
      onCloseChangePassword ()
      {
        this.modal_password = false;
        this.cp_password = null;
        this.cp_confirm_password = null;
        this.$v.$reset();
      },
      onChangePassword ()
      {
        this.$v.$touch();
        let self = this;
        if (!this.$v.cp_password.$invalid && !this.$v.cp_confirm_password.$invalid)
        {
          this.$store.dispatch ('isLoadingOn');
          this.$axios.post ("/auth/change_password", { 'password' : this.cp_password })
            .then (() => {
              self.$store.dispatch ('isLoadingOff');
              self.onCloseChangePassword ();
              self.$dialog.alert ({
                title: self.$t ("change_password"),
                body: self.$t ("change_password_success")
              }, { customClass: 'cd-dialog cd-dialog--success' });
            })
            .catch (() => {
              self.$store.dispatch ('isLoadingOff');
              self.$dialog.alert ({
                title: self.$t ("change_password"),
                body: self.$t ("server_error")
              }, { customClass: 'cd-dialog cd-dialog--danger' });
            })
        }
      }
    }
  }

</script>
<style>
/* Modal de "Cambiar contraseña" */
.cd-form-error {
  display: block;
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}
.navbar .navbar-toggler .burger-lines{
  background: #888 !important;
}
.no-line{
  line-height: initial !important;
}
.dropdown-menu{
  margin-top: 5px  !important;
  border-radius: 0px;
}
.dropdown-menu div
{
  max-height: calc(100vh - 76px);
  overflow: auto;
}
.font10{
  font-size:10px;
}
.font12{
  font-size:12px;
}
.font14{
  font-size:14px;
}
.font18{
  font-size:18px;
}
.font25{
  font-size:25px;
}
.font30{
  font-size:30px;
}
.notifications-dropdown .dropdown-menu{
  width:400px;
}
.notifications-dropdown  .dropdown-item{
  padding: 0.25rem 1.5rem;

}
.calibri{
    font-family: "calibri light" !important;
}
/* LOPD modal (v2 restyling).
   The consent text scrolls on its own so the accept button stays in view. It
   used to live inside the scrolling area (classContent="contentModal", a flat
   "height: 600px; overflow: hidden scroll"), so it could only be reached
   after scrolling the whole policy, the scrollbar track showed even when the
   text was shorter, and on a laptop screen the modal did not fit at all.
   A vh cap keeps it inside the viewport whatever the screen. */
.cd-modal .cd-lopd-text {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}

/* FileExplorer.vue declares a bare ".modal-body { max-height: 500px;
   overflow-y: auto }" in a non-scoped <style>, so once the documents view has
   been loaded that rule reaches every modal in the app — this one included,
   which then scrolled its body on top of the text already scrolling inside
   it. Here the body must not scroll at all: the whole point of the inner
   scroll is to keep the accept button in view. .w-full is only used by this
   modal, so the two classes stay above the one-class rule. */
.cd-modal.w-full .modal-body {
  max-height: none;
  overflow: visible;
}

/* Closes the policy at the end of the scroll, rather than acting as a footer:
   reaching it is what tells the user they got to the bottom. */
.cd-modal .cd-lopd-actions {
  padding-top: 1.25rem;
  margin-top: 1rem;
  border-top: 1px solid var(--cd-border-light);
  text-align: center;
}
/* Same shape as the footer buttons of the other migrated modals; this one
   cannot use the real footer because the modal is rendered with
   showfooter="false" and its own accept handler. */
.cd-modal .cd-lopd-actions .btn {
  height: 38px;
  min-width: auto;
  margin: 0;
  padding: 0 24px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
}
.cd-modal .cd-lopd-actions .btn i {
  margin-right: 6px;
}

/* ley_rgpd.vue tags every <p> with .calibri, and the rule above forces
   font-family: "calibri light" with no fallback. That font ships with Office
   on Windows; anywhere else the browser falls back to its default serif and
   the policy renders in a different typeface than the rest of the app. Inside
   the modal it inherits the app font instead. !important is needed because
   the rule being overridden carries it. */
.cd-modal .calibri {
  font-family: inherit !important;
}

.dropdown-item{cursor: pointer}
.modal_button{

  position: absolute;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
}
.modal-lg {
  max-width: 600px;
}
.modal-xl {
  max-width: 750px;
}
@media (min-width: 992px)
{
 .w-full .modal-dialog{
    max-width: 80%;
  } 
}
.navbar .navbar-nav .nav-item .nav-link{ color: #888888}
.navbar-brand{padding-top: 0px; padding-bottom: 0px}

@media (max-width: 40em) {
  .card-header img{
    width: 90%;
  }

}

.navbar-brand img{
  width: 130px;
  height: 55px;
}

/* ---------- Menú de usuario ---------- */
/* Base de los iconos SVG-mask (mismo mecanismo que en el sidebar, pero
   ahí queda encapsulado dentro de un selector que no llega hasta aquí). */
.icon-svg {
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
.user-menu .dropdown-toggle {
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
}
.user-menu .dropdown-toggle::after {
  display: none !important;
}
/* ---------- Identidad junto al avatar del navbar ---------- */
/* Los mismos datos que la cabecera del desplegable, que los sigue mostrando.
   text-transform y letter-spacing se declaran porque el disparador es un
   <button class="btn nav-link">, y .btn del tema pone el texto en mayúsculas. */
.user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-transform: none;
  letter-spacing: normal;
}
/* Dos líneas (nombre y empresa) con el interlineado justo para que el bloque no
   pase de los 42px del avatar y la barra no crezca de alto. */
.user-trigger__identity {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  line-height: 1.2;
  text-align: left;
}
.user-trigger__name,
.user-trigger__company {
  display: block;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-trigger__name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #2a2f3c;
}
/* Empresa: bajo el nombre, más pequeña y con el mismo gris que usa la cabecera
   del desplegable. */
.user-trigger__company {
  font-size: 0.69rem;
  font-weight: 400;
  color: #6b7280;
}
/* En pantallas estrechas se mantiene visible; solo se recorta antes para que un
   nombre largo no empuje al resto de la barra. */
@media (max-width: 767.98px) {
  .user-trigger__name,
  .user-trigger__company {
    max-width: 150px;
  }
}

.user-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(46, 158, 79, 0.14);
}
.user-avatar .icon-svg {
  width: 22px !important;
  height: 22px;
  margin: 0 !important;
  color: var(--cd-brand-green, #2E9E4F);
}
.user-avatar__dot {
  position: absolute;
  right: 1px;
  bottom: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--cd-brand-green, #2E9E4F);
  border: 2px solid #fff;
}
.user-avatar--sm {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

/* ---------- Enlace de contacto (junto al menú de usuario) ---------- */
/* Reutiliza .user-avatar para que sea idéntico en tamaño/forma al icono
   de usuario, solo cambia el icono interior. */
.contact-link {
  display: flex;
  align-items: center;
  margin-right: 14px;
}
.user-avatar--plain {
  background: transparent;
  transition: background 0.15s ease;
}
.contact-link a:hover .user-avatar--plain {
  background: rgba(46, 158, 79, 0.14);
}
.icon-svg.icon-mail-forward {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5'/><path d='M3 6l9 6l9 -6'/><path d='M15 18h6'/><path d='M18 15l3 3l-3 3'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5'/><path d='M3 6l9 6l9 -6'/><path d='M15 18h6'/><path d='M18 15l3 3l-3 3'/></svg>");
}

/* Por debajo de "lg", Bootstrap cambia por defecto los dropdowns de navbar
   a position:static y sin fondo/sombra (pensado para menús móviles clásicos
   que se expanden en línea). Aquí queremos que este menú se vea y comporte
   exactamente igual en cualquier tamaño, así que se fuerza explícitamente
   el estilo de tarjeta flotante en todos los anchos. */
html body .user-menu .dropdown-menu {
  position: absolute !important;
  right: 10px !important;
  margin-top: 0 !important;
  min-width: 260px;
  padding: 0 0 8px;
  background: #fff !important;
  border: 1px solid var(--cd-border-light, #e2e5ec) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
}
/* El triángulo indicador que trae el template de base queda descolocado
   (pensado para otro layout). Se anula y se pone uno propio, centrado en
   el icono del usuario. Vive dentro del propio .dropdown-menu (así lo
   coloca base-dropdown), así que se posiciona relativo a su esquina
   superior derecha, no al <li>. */
.user-menu .dropdown-menu:before,
.user-menu .dropdown-menu:after {
  display: none !important;
}
.user-menu__arrow {
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid var(--cd-border-light, #e2e5ec);
  border-top: 1px solid var(--cd-border-light, #e2e5ec);
  transform: rotate(45deg);
  z-index: 9001;
}
.user-menu__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}
.user-menu__identity {
  min-width: 0;
}
.navbar-collapse .navbar-nav .user-menu__name,
.navbar-collapse .navbar-nav .user-menu__role {
  line-height: normal !important;
}
.user-menu__name {
  margin: 0;
  font-weight: 700;
  color: #2a2f3c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-menu__company {
  margin: 0;
  font-size: 0.82rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-menu__role {
  margin: 0;
  font-size: 0.82rem;
  color: #8a8f9c;
}
.user-menu .divider {
  height: 1px;
  margin: 4px 0;
  background: var(--cd-border-light, #e2e5ec);
}
.user-menu__item {
  display: flex !important;
  align-items: center;
  gap: 10px;
  color: #3a3f4b !important;
}
.user-menu__item .icon-svg {
  width: 18px !important;
  height: 18px;
  margin: 0 !important;
  color: #6b7280;
  flex-shrink: 0;
}
.user-menu__item:hover {
  background: rgba(46, 158, 79, 0.1) !important;
  color: var(--cd-brand-green, #2E9E4F) !important;
}
.user-menu__item:hover .icon-svg {
  color: var(--cd-brand-green, #2E9E4F);
}

.icon-svg.icon-key {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0'/><path d='M15 9h.01'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0'/><path d='M15 9h.01'/></svg>");
}
.icon-svg.icon-bell {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6'/><path d='M9 17v1a3 3 0 0 0 6 0v-1'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6'/><path d='M9 17v1a3 3 0 0 0 6 0v-1'/></svg>");
}
.icon-svg.icon-logout {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2'/><path d='M9 12h12l-3 -3'/><path d='M18 15l3 -3'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2'/><path d='M9 12h12l-3 -3'/><path d='M18 15l3 -3'/></svg>");
}
</style>
